import { Spin, Typography } from "antd";

const { Text } = Typography;

type LoadingOverlayProps = {
  progress: number;
};

export const LoadingOverlay = ({ progress }: LoadingOverlayProps) => (
  <div
    style={{
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255, 255, 255, 0.9)",
      zIndex: 100,
    }}
  >
    <Spin size="large" />
    <Text style={{ marginTop: 16 }}>
      Loading Prestige Model... {Math.round(progress)}%
    </Text>
  </div>
);
